<script>

import LoadingScreen from '@/components/General/LoadingScreen'

export default {
	name: 'PageWasNotFound',

	components: {
		LoadingScreen
	},
	props: {'auth':Object, 'secData':Object, 'params':Object},
	data() {
		return {
			isLoading:true,
		}
	},
	
	mounted:function(){
		this.isLoading=false
	},
	
	methods: {
	
	},	
	
			
	watch: {
		
	},

	computed:{
		
	},
	
}

</script>

<template>

		<div>
			<LoadingScreen :isLoading="isLoading"></LoadingScreen>

			<section id="registracia" class="box-flex">
				<div class="container">
					<div class="row">
						<div class="col-12 box-flex">
							<h2>{{$t('msgCore.PageWasNotFound')}}</h2>
						</div>
					</div>
				</div>
			</section>
		</div>	

</template>


